module.exports = __webpack_public_path__ + "fonts/1d699af3-0e50-4c4b-a343-42d071e85714.ff9a64c1.eot";